import { Alert } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Done } from "lib/@components/done"

export function MissingScheduleGroupsDialog() {
    return (
        <DialogBox
            title="Schedule Group Required"
            Actions={Done}
            okCaption="Ok"
            data-cy="missing-schedule-groups-dialog"
        >
            <Alert severity="error" sx={{ mt: 1 }}>
                At least one schedule group must be selected before submitting for review.
            </Alert>
        </DialogBox>
    )
}
